import { useAuth } from "contexts/AuthContext";
import MainRightPanel from "./mainRightPanel";
import StakeholderRightPanel from "./stakeholderRightPanel";

const VISIBILITY_RULES: Record<string, string[]> = {
    submitted: ["GeneralAttorney", "Coordinator"],
};

function LegalAwarenessCreationRightPanel({ request }: { request: any }) {
    const contextData = useAuth();
    const userRoles = contextData?.user?.roles || [];

    const canShow = VISIBILITY_RULES[request.status]?.some(role =>
        userRoles.includes(role)
    );

    return (
        <>
            {contextData?.user?.user_type === "external" ? <StakeholderRightPanel request={request} /> :
                <MainRightPanel request={request} />
            }

        </>
    );
}

export default LegalAwarenessCreationRightPanel;


